/* eslint-disable */
// FIXME: enable eslint
import axios from "axios";
import VueCookies from "vue-cookies";

export default (config, userToken) => {
  const token = userToken ? userToken : VueCookies.get(config.api.tokenName);
  const headers = {
    "Accept": "application/json",
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return axios.create({
    baseURL: config.api.base,
    withCredentials: false,
    headers,
    xsrfHeaderName: "X-CSRFToken",
    xsrfCookieName: config.api.csrfToken,
  });
};
